class audit {
    constructor(
        cat,
        codApply,
        id,
        comment,
        ws,
    
    
    ){
        this.cat = cat
        this.codApply = codApply
        this.id = id
        this.comment = comment
        this.ws = ws

    
    }
    static fromJson({
        cat,
        codAplica,
        comentId,
        comentario,
        ws,
        
    }){
        return new audit(
            cat,
            codAplica,
            comentId,
            comentario,
            ws,
            
        )
    }
    }
    export default audit
    